module.exports = __webpack_public_path__ + "static/img/light-bg-record.d35d5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/light-bg-record.svg
// module id = Y+lQ
// module chunks = 4